module.exports = __webpack_public_path__ + "img/1577271070.23993e25.jpg";